export var defined = function (x) { return x !== undefined && x != null && !Number.isNaN(x); };
//# sourceMappingURL=defined.js.map